/* ============================================================
   CardLineGames — Guía de Inicio
   Interactive behaviors: scroll reveals, 3D cards, particles, etc.
   Scoped to .guia-inicio container for Shopify theme integration.
   ============================================================ */

(function () {
    'use strict';

    function init() {
        var container = document.querySelector('.guia-inicio');
        if (!container) return;

        // ─── Reading Progress Bar ────────────────────────────────
        var progressBar = document.getElementById('guiaProgressBar');

        function updateProgress() {
            var scrollTop = window.scrollY;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
            if (progressBar) progressBar.style.width = progress + '%';
        }

        // ─── Table of Contents ───────────────────────────────────
        var toc = document.getElementById('guiaToc');
        var tocItems = container.querySelectorAll('.toc__item');
        var sections = container.querySelectorAll('.section');

        function updateToc() {
            if (!toc) return;

            // Show/hide TOC
            if (window.scrollY > window.innerHeight * 0.6) {
                toc.classList.add('toc--visible');
            } else {
                toc.classList.remove('toc--visible');
            }

            // Highlight active section
            var current = '';
            sections.forEach(function (section) {
                var rect = section.getBoundingClientRect();
                if (rect.top <= window.innerHeight * 0.4) {
                    current = section.id;
                }
            });

            tocItems.forEach(function (item) {
                item.classList.remove('toc__item--active');
                if (item.getAttribute('data-section') === current) {
                    item.classList.add('toc__item--active');
                }
            });
        }

        // ─── Scroll Reveal (Intersection Observer) ───────────────
        var revealElements = container.querySelectorAll('.reveal-scroll');

        var revealObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var siblings = entry.target.parentElement.querySelectorAll('.reveal-scroll');
                    var index = Array.from(siblings).indexOf(entry.target);
                    if (index < 0) index = 0;

                    setTimeout(function () {
                        entry.target.classList.add('reveal-scroll--visible');
                    }, index * 60);

                    revealObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.08,
            rootMargin: '0px 0px -60px 0px'
        });

        revealElements.forEach(function (el) {
            revealObserver.observe(el);
        });

        // ─── 3D Card Tilt Effect (only small gallery cards) ──────
        var cards = container.querySelectorAll('.card-3d--small[data-tilt]');

        cards.forEach(function (card) {
            card.addEventListener('mousemove', function (e) {
                var rect = card.getBoundingClientRect();
                var x = e.clientX - rect.left;
                var y = e.clientY - rect.top;
                var centerX = rect.width / 2;
                var centerY = rect.height / 2;

                var rotateX = ((y - centerY) / centerY) * -8;
                var rotateY = ((x - centerX) / centerX) * 8;

                card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale(1.02)';

                var shine = card.querySelector('.card-3d__shine');
                if (shine) {
                    var px = (x / rect.width) * 100;
                    var py = (y / rect.height) * 100;
                    shine.style.background = 'radial-gradient(circle at ' + px + '% ' + py + '%, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 60%)';
                    shine.style.opacity = '1';
                }
            });

            card.addEventListener('mouseleave', function () {
                card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale(1)';
                card.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
                var shine = card.querySelector('.card-3d__shine');
                if (shine) shine.style.opacity = '0';

                setTimeout(function () {
                    card.style.transition = '';
                }, 500);
            });

            card.addEventListener('mouseenter', function () {
                card.style.transition = 'box-shadow 0.3s';
            });
        });

        // ─── Smooth Scroll for Anchors ───────────────────────────
        container.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
            anchor.addEventListener('click', function (e) {
                var target = document.querySelector(anchor.getAttribute('href'));
                if (target) {
                    e.preventDefault();
                    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
                    var offset = headerHeight + 10;
                    var top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                }
            });
        });

        // ─── Particle Background ─────────────────────────────────
        var canvas = document.getElementById('guiaParticles');
        if (canvas) {
            var ctx = canvas.getContext('2d');
            var particles = [];
            var animationId;
            var canvasWidth, canvasHeight;

            function resizeCanvas() {
                canvasWidth = canvas.width = window.innerWidth;
                canvasHeight = canvas.height = window.innerHeight;
            }

            function Particle() {
                this.reset();
            }

            Particle.prototype.reset = function () {
                this.x = Math.random() * canvasWidth;
                this.y = Math.random() * canvasHeight;
                this.size = Math.random() * 2 + 0.5;
                this.speedX = (Math.random() - 0.5) * 0.3;
                this.speedY = -Math.random() * 0.4 - 0.1;
                this.opacity = Math.random() * 0.5 + 0.1;
                this.fadeSpeed = Math.random() * 0.003 + 0.001;
                this.growing = Math.random() > 0.5;
            };

            Particle.prototype.update = function () {
                this.x += this.speedX;
                this.y += this.speedY;

                if (this.growing) {
                    this.opacity += this.fadeSpeed;
                    if (this.opacity >= 0.6) this.growing = false;
                } else {
                    this.opacity -= this.fadeSpeed;
                    if (this.opacity <= 0) this.reset();
                }

                if (this.y < -10 || this.x < -10 || this.x > canvasWidth + 10) {
                    this.reset();
                    this.y = canvasHeight + 10;
                }
            };

            Particle.prototype.draw = function () {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(124, 58, 237, ' + this.opacity + ')';
                ctx.fill();
            };

            function initParticles() {
                resizeCanvas();
                var count = Math.min(40, Math.floor(canvasWidth / 35));
                particles = [];
                for (var i = 0; i < count; i++) {
                    particles.push(new Particle());
                }
            }

            function animateParticles() {
                ctx.clearRect(0, 0, canvasWidth, canvasHeight);
                particles.forEach(function (p) {
                    p.update();
                    p.draw();
                });
                animationId = requestAnimationFrame(animateParticles);
            }

            document.addEventListener('visibilitychange', function () {
                if (document.hidden) {
                    cancelAnimationFrame(animationId);
                } else {
                    animateParticles();
                }
            });

            initParticles();
            animateParticles();

            window.addEventListener('resize', function () {
                resizeCanvas();
            });
        }

        // ─── Scroll Listeners (throttled) ────────────────────────
        var ticking = false;

        function onScroll() {
            if (!ticking) {
                requestAnimationFrame(function () {
                    updateProgress();
                    updateToc();
                    ticking = false;
                });
                ticking = true;
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });

        // Initial calls
        updateProgress();
        updateToc();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
